// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jYqs","footer":"styles_footer__2KZzt"};